import { motion } from 'motion/react'
import { useGetAppPage } from '../useGetAppPage'

export function PageHeader({ children }: { children: React.ReactNode }) {
  const {
    data: { title },
  } = useGetAppPage()
  return (
    <motion.div
      layout
      className="sticky top-0 z-10 flex w-full justify-between gap-10 border-b bg-background/50 py-2 pl-5 backdrop-blur"
    >
      <motion.h6 layout className="text-2xl font-bold backdrop-blur">
        {title}
      </motion.h6>
      {children}
    </motion.div>
  )
}
